import React from 'react';
import PasswordStrengthMeter from 'emerald-ui/lib/PasswordStrengthMeter';
import TextField from 'emerald-ui/lib/TextField';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs(
    [
      {
        component: PasswordStrengthMeter,
        componentName: 'PasswordStrengthMeter',
      },
    ],
    'PasswordStrengthMeter'
  ),
  description: (
    <span>
      A helper that shows the strength of a password in a <span className="code">Popover</span>. It usually wraps a{' '}
      <span className="code">TextField</span>.
    </span>
  ),
  codeSamples: [
    {
      title: 'With TextField',
      scope: { PasswordStrengthMeter, TextField },
      whiteBackground: true,
      code: `<div style={{ display: 'flex' }}>
  <PasswordStrengthMeter id="foo-id">
    <TextField
      label="Password"
      type="password"
      style={{ width: '250px' }}
    />
  </PasswordStrengthMeter>
</div>`,
    },
  ],
};
